// Fixed letterhead details shared by both Purchase Order print templates
// (Central/print.jsx and Central/MasterPOPrint.jsx) - kept in one place so
// they can't drift out of sync when they need to change again.
export const PO_EVENT_TITLE = 'Istefadah Ilmiyah 1448';
export const PO_BILL_TO_NAME = 'Dawat e Hadiyah';
export const PO_DELIVERY_ADDRESS_LINES = [
  'Begumwadi Store, Salabatpura,',
  'Syndicate Samosa ni Gali,',
  'Surat - 395003',
];
